// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.combobox {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
}

.combobox__btn {
    display: flex;
    padding: 0px 2px;
    margin: 0;
    height: 100%;
    align-items: center;
}

.combobox__name {
    flex: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: block;
    width: 100%;
    margin-right: 2px;
}

.combobox__arrow {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.combobox__btn.rotated .combobox__arrow svg {
    transform: rotate(180deg);
}
`, "",{"version":3,"sources":["webpack://./src/controls/combobox/combobox.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".combobox {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.combobox__btn {\r\n    display: flex;\r\n    padding: 0px 2px;\r\n    margin: 0;\r\n    height: 100%;\r\n    align-items: center;\r\n}\r\n\r\n.combobox__name {\r\n    flex: 1;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    display: block;\r\n    width: 100%;\r\n    margin-right: 2px;\r\n}\r\n\r\n.combobox__arrow {\r\n    width: 16px;\r\n    height: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.combobox__btn.rotated .combobox__arrow svg {\r\n    transform: rotate(180deg);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
